import Vue from 'vue'
import { mapMutations } from 'vuex'
export default {
  methods: {
    ...mapMutations(['cerrarSesion']),
    formatNumberBySeparator (number, separator = '.') {
      if (!number || number.length === 0) {
        return false
      }
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    },
    swalAlertError (e) {
      Vue.swal({
        title: e.response.data.title,
        text: e.response.data.text,
        icon: 'error',
      })
      if (
        // Si es un error de validación (token o rol) y el token caducó o no existe, cierra sesión
        e.response.data.code &&
        (e.response.data.code === 'token-timed-out' ||
          e.response.data.code === 'no-token' ||
          e.response.data.code === 'invalid-user')
      ) {
        this.cerrarSesion()
      }
    },
    getDateByDateTime (dateTime) {
      const date = dateTime.substring(0, dateTime.indexOf('T'))
      const dateArr = date.split('-')
      const reverseArr = dateArr.reverse()
      return reverseArr.join('-')
    },
    getTimeByDateTime (dateTime) {
      const time = dateTime.substring(dateTime.indexOf('T') + 1)
      const timeArr = time.split(':')
      return timeArr[0] + ':' + timeArr[1]
    },
    debounce (fn, delay) {
      var timeoutID = null
      return function () {
        clearTimeout(timeoutID)
        var args = arguments // Argumentos pasados a la función
        var that = this

        timeoutID = setTimeout(function () {
          fn.apply(that, args) // Invoca la función pasándole los argumentos
        }, delay)
      }
    },
    cleanLineBreaks (str) {
      return str && str.length > 0 ? str.replace(/(\\r)*\\n/g, '') : ''
    },
    abrirURL (url, newTab = true) {
      if (newTab) {
        window.open(url, '_blank')
      } else {
        window.open(url)
      }
    },
    abrirTelefono (tel) {
      window.open(`tel:${tel}`)
    },
    ordenarSucursalesString (sucursales) {
      /* recibe state "sucursales" y lo transforma en string tipo "Providencia, Santiago Centro y Viña del Mar" */
      let str = ''
      sucursales.map((el, idx) => {
        str += el.Nombre
        if (idx === sucursales.length - 2) {
          str += ' y '
        } else if (idx < sucursales.length - 1) {
          str += ', '
        }
      })

      return str
    },

    detectAppleDevice () {
      const userAgent = navigator.userAgent.toLowerCase()
      const platform = navigator.platform.toLowerCase()
      let isApple = false
      // Detectar iPhone, iPad o dispositivos macOS
      if (
        /iphone|ipad|ipod|mac/.test(userAgent) ||
        platform.includes('mac') ||
        platform.includes('ios')
      ) {
        isApple = true
      }
      return isApple
    },
    async descargarArchivo (url, nombre = 'archivo-descargado') {
      try {
        const response = await fetch(url, {
          method: 'GET',
        })
        if (!response.ok) {
          throw new Error(`Error en la descarga: ${response.statusText}`)
        }
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', nombre)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('Error al descargar el archivo:', error)
      }
    },
  },
}
